import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AuthenticationService } from '@core/services/authentication.serivce';

// telerik imports
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LayoutModule, GridLayoutModule, TabStripModule } from '@progress/kendo-angular-layout';
import { TextBoxModule, TextAreaModule, CheckBoxModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { BreadCrumbModule } from '@progress/kendo-angular-navigation';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { NotificationModule } from '@progress/kendo-angular-notification';

import { SharedModule } from '@shared/shared.module';
import { HttpClient } from '@angular/common/http';

import { ItemsRoutingModule } from './items-routing.module';
import { ItemListComponent } from './item-list/item-list.component';
import { ItemService } from './services/item-service';
import { AddToCartComponent } from './add-to-cart/add-to-cart.component';
import { ItemComponent } from './item/item.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { UploadsModule } from "@progress/kendo-angular-upload";
import { ItemSplitComponent } from './item-split/item-split.component';
import { ItemDocumentComponent } from './item-document/item-document.component';
import { SelectFieldComponent } from '../../shared/components/select-field/select-field.component';
import { DetailComponent } from '../../shared/components/detail/detail.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { DetailLayoutComponent } from '../../shared/components/detail-layout/detail-layout.component';
import { SideCartComponent } from '../../shared/components/side-cart/side-cart.component';
import { CartService } from '../../shared/services/cart.service';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { ContextMenuModule } from '@progress/kendo-angular-menu';


@NgModule({
  imports: [
    LayoutModule,
    NumericTextBoxModule,
    LabelModule,
    GridLayoutModule,
    GridModule,
    DialogModule,
    TextBoxModule,
    TextAreaModule,
    EditorModule,
    SelectFieldComponent,
    SideCartComponent,
    DetailComponent,
    ScrollViewModule,
    SearchComponent,
    DetailLayoutComponent,
    ItemsRoutingModule,
    ContextMenuModule,
    UploadsModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [
    ItemListComponent,
    AddToCartComponent,
    ItemComponent,
    ItemSplitComponent,
    ItemDocumentComponent
  ],
  providers: [AuthenticationService, ItemService]
})
export class ItemsModule { }
